import { Contact, ContactClient, fetchContacts } from '@frontend/contact';
import { useEffect, useMemo, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../redux/store';
import { ContactSelectProps } from './contact-select.component';

interface ViewProps {
    options: { value: string; label: string }[];
    value?: { value: string; label: string };
    onScrollToBottom: () => void;
    search: (inputValue: string, callback: (options: { value: any; label: string }[]) => void) => void;
}

const pageSize = '100';
const useContactSelect = (props: ContactSelectProps): ViewProps => {
    const dispatch = useAppDispatch();
    const timer = useRef<NodeJS.Timeout | null>(null);
    const [count, changeCount] = useState<number>(0);
    const [index, changeIndex] = useState<number>(0);
    const contactsState = useAppSelector((state) => state.contacts);
    const [options, changeOptions] = useState<{ value: string; label: string }[]>([]);
    const value = useMemo(() => {
        if (typeof props.value == 'string') return options.find((o) => o && o.value == props.value);
        return props.value;
    }, [props.value, options]);

    useEffect(() => {
        dispatch(fetchContacts({ index: index.toString(), size: pageSize }));
    }, [index]);

    useEffect(() => {
        if (contactsState.contacts) {
            changeCount(contactsState.contacts.count);
            changeOptions(mapResultSetToOptions(contactsState.contacts.results));
        }
    }, [contactsState.contacts]);

    const search = (inputValue: string, callback: (options: { value: any; label: string }[]) => void) => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            ContactClient.fetchContacts({ search: inputValue, index: '0', size: pageSize }).then((result) => {
                callback(mapResultSetToOptions(result.results));
            });
        }, 500);
    };

    const onScrollToBottom = () => {
        if (count / parseInt(pageSize) > 1 && parseInt(pageSize) * index < count) {
            changeIndex(index + 1);
        }
    };

    return {
        options,
        value,
        onScrollToBottom,
        search
    };
};

function mapResultSetToOptions(contacts: Contact[]): { value: any; label: string }[] {
    return contacts.map((c) => ({ value: c.id, label: c.first_name + ' ' + c.last_name }));
}

export default useContactSelect;
